import React from 'react';
import { Clock } from 'lucide-react';

const TIME_SLOTS = [
  '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
  '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
  '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00'
];

const TimeSelector = ({ selectedTime, onTimeSelect }) => {
  return (
    <div>
      <label className="text-[#FFCC00] text-sm font-semibold uppercase tracking-wider mb-3 flex items-center gap-2">
        <Clock className="w-4 h-4" />
        Ora di Deposito
      </label>
      <div className="grid grid-cols-4 sm:grid-cols-6 gap-2">
        {TIME_SLOTS.map(time => (
          <button
            key={time}
            onClick={() => onTimeSelect(time)}
            data-testid={`time-slot-${time.replace(':', '')}`}
            className={`
              py-2 px-3 text-sm transition-all border
              ${selectedTime === time
                ? 'bg-[#FFCC00] text-[#0A0A0A] font-bold border-[#FFCC00]'
                : 'bg-[#0A0A0A] text-white border-[#2A2A2A] hover:border-[#FFCC00]/50'
              }
            `}
          >
            {time}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TimeSelector;
